import React, { useEffect, useState } from 'react'
import withLayout from '../../../hocs/Layout'
import OrderTimeline from './orderTimeline'
import AddressQualityCard from './AddressQualityCard'
import RtoRiskCard from './RtoRiskCard'
import Loader from '../../../common/Loader'
import { apiConstants, get, postGeneric, post, getGeneric } from '../../../common/constants'
import { useSnackbar } from 'notistack'
import { useLocation, useNavigate } from 'react-router-dom'
import {
  Button,
  Chip,
  Grid,
  Typography,
  Stack,
  Link,
  Tooltip,
  Box,
} from '@mui/material'
import {
  useLazyGetShipmentDetailQuery,
  useGetB2BOdaCheckQuery,
} from '../../../redux/commonRTK'
import CancelIcon from '@mui/icons-material/Cancel'
import {
  parseDateAndTime,
  addressStringWithPrefix,
  formatDate,
  formatCurrency,
  maskPhoneNumber,
  maskEmail,
  maskAddress,
  shouldMaskData,
  shouldMaskDataPD,
  getS3SignedUrl,
  addressStringWithPrefixRAddr,
  decodeChannelAccess,
  refreshS3SignedUrl,
} from '../../../helpers/UtilityHelper'
import MUIModal from '../../../common/MUIModal'
import ProzoDataGrid from '../../../common/ProzoDataGrid'
import { ProductImageThumbs, imagesOf } from '../../../common/ImageLightbox'
import PageTitle from '../../../common/PageTitle'
import ConfirmDialog from '../../../common/ConfirmDialog'
import { useSelector } from 'react-redux'
import QcDetails from '../list2/QcDetails'
import { getMerchant, getToken, isAdmin } from '../../../helpers/ReduxHelpers'
import jwt_decode from 'jwt-decode'
import PIIDetails from '../../PIIDetails'
import StatusBanner from './StatusBanner'
import SummaryCards, { InfoRow } from './SummaryCards'
import DocumentsBar from './DocumentsBar'
import SectionCard from './SectionCard'
import { AdditionalDocumentsCard, CurrentAppointmentCard, PreviousAppointmentsCard } from './PtlDocumentCards'
import { EMS_V2_ENABLED } from '../../../../routes/emsV2Visibility'
import { NAVY, SUBTLE, BORDER } from '../../../styles/foundation/colors'
import { FONT, SIZE, WEIGHT } from '../../../styles/foundation/typography'

const exclude =
  'terminalStatus.firstEvent,order_history.courierPartnerId,createdDate,courierDetail.key,courierDetail.name,itemList.hsn,shippingCharge,transactionCharge,giftwrapCharge,dispatchMode,proshipDeliveryTat,courierDeliveryTat,lastStatusUpdateTime,epd,lifeCycleComplete,merchant,courier,merchantPricing.pricingObj,version,orderManifest,courierPricing,overriddenCourierAccountCode,isDiscrepancyRaised,discrepancyId,securityKey,sortCode,channelType,createdByUser,skipRule,modifiedByUser,rvp_reason,customer_detail,cpErrorList,mongoLabelSignedUrlDetails,overriddenCourierRule,mongoInvoiceSignedUrlDetails,merchant,merchantPricing.merchantRateCard,modifiedByUser,lastModifiedDate,label_url,invoice_url,b2bPackageLabelUrl'
// const columns = [
//     {
//         field: 'item_name',
//         headerName: 'Product name',
//         flex: 1.5
//     },
//     {
//         field: 'sku_id',
//         headerName: 'SKU',
//         flex: 1
//     },
//     {
//         field: 'units',
//         headerName: 'Qty',
//         flex: 0.8
//     },
//     {
//         field: 'tax',
//         headerName: 'Tax',
//         flex: 0.8,
//         // type: 'number',
//         valueFormatter: (params) => {
//             if (params.value == null) {
//                 return '';
//             }

//             const valueFormatted = Number(params.value).toLocaleString();
//             return `${valueFormatted} %`;
//         },
//     },
//     {
//         field: 'selling_price',
//         headerName: 'Price',
//         flex: 0.8,
//         // type: "number",
//         valueFormatter: (params) => {
//             if (params.value == null) {
//                 return '';
//             }

//             const valueFormatted = Number(params.value).toLocaleString();
//             return `₹ ${valueFormatted}`;
//         },
//     },
//     {
//         field: 'item_url',
//         headerName: 'Item Image',
//         flex: 1,
//         renderCell: (params) => {
//             const { row } = params;
//             return (
//                 <>
//                     {row?.item_url ?
//                         <Link href={row?.item_url} target='_blank'>Image</Link> : "-"
//                     }
//                 </>
//             )
//         },
//     },
//     {
//         field: 'return_reason',
//         headerName: 'Return Reason',
//         flex: 1,
//         renderCell: (params) => {
//             const { row } = params;
//             return (
//                 <>
//                     {row?.return_reason ?? '-'}
//                 </>
//             )
//         },
//     }
// ]

const columns2 = [
  {
    field: 'item_name',
    headerName: 'Product name',
    flex: 1.5,
  },

  {
    field: 'units',
    headerName: 'Boxes',
    flex: 0.8,
  },
  {
    field: 'length',
    headerName: 'Length (cm)',
    flex: 0.8,
    renderCell: (params) => {
      const { row } = params
      return row?.additional?.length
    },
  },
  {
    field: 'additional.breadth',
    headerName: 'Breadth (cm)',
    flex: 0.8,
    renderCell: (params) => {
      const { row } = params
      return row?.additional?.breadth
    },
  },
  {
    field: 'additional.height',
    headerName: 'Height (cm)',
    flex: 0.8,
    renderCell: (params) => {
      const { row } = params
      return row?.additional?.height
    },
  },
  {
    field: 'additional.weight',
    headerName: 'Total Weight (kg)',
    flex: 0.8,
    renderCell: (params) => {
      const { row } = params
      return (row?.additional?.weight / 1000).toFixed(2)
    },
  },
]

function useQuery() {
  const { search } = useLocation()

  return React.useMemo(() => new URLSearchParams(search), [search])
}

const OrderDetail = () => {
  // const { data: courierData = [] } = useGetCouriersQuery()
  const { enqueueSnackbar } = useSnackbar()
  let query = useQuery()
  // const dispatch = useDispatch();
  // const [cancelLoading, setLoading] = useState(false);
  // const { orderDetailInfo, loading } = useSelector((state) => state.orderListSlice);
  const [getShipmentDetail, { data, isLoading, isFetching }] = useLazyGetShipmentDetailQuery()

  const waybill = query.get('waybill')
  const waVerified = query.get('verified')
  const [reload, setReload] = useState(0)
  const [page, setPage] = useState(0)
  const [sizePerPage, setSizePerPage] = useState(10)
  // const [rowCountState, setRowCountState] = useState(remarks?.count || 0);
  const [ndrCalls, setNdrCalls] = useState([])
  const [nprCalls, setNprCalls] = useState([])
  const [ndrQ, setNdrQ] = useState([])
  const [ndrQModal, setNdrQModal] = useState(false)
  const [cancelConfirm, setCancelConfirm] = useState(false)
  const { report } = useSelector((state) => state)
  const { piiAccessAllow } = jwt_decode(getToken())
  const [row, setRow] = useState()
  const [viewQc, setViewQc] = useState(false)
  const [supportTickets, setSupportTickets] = useState([])
  const [statusList, setStatusList] = useState([])
  // sku_id -> Product Master images[] for the items on this order
  const [skuImageMap, setSkuImageMap] = useState({})
  const merchant = getMerchant()
  const channelAccess = decodeChannelAccess()
  // reportData
  const [insuranceDetails, setInsuranceDetails] = useState(null)
  const [remittanceReport, setRemittanceReport] = useState(null)
  const fetchInsuranceDetails = async (awbNumber) => {
    const requestBody = {
      collection: 'proposals',
      andfilter: [
        {
          field: 'merchantOid',
          operator: 'eq',
          value: merchant.id,
        },
        {
          field: 'awbNumber',
          operator: 'eq',
          value: awbNumber,
        },
      ],
    }
    return postGeneric(apiConstants.REPORT_GENERIC_SEARCH, requestBody)
      .then((res) => {
        if (res?.data?.data?.length > 0) {
          setInsuranceDetails(res?.data?.data?.[0])
        }
      })
      .catch((err) => {
        console.log(err)
      })
  }



  // Freshdesk's status labels, for the old Support Tickets list; EMS V2 tickets carry their own.
  useEffect(() => {
    if (EMS_V2_ENABLED) return
    const fetchStatusList = async () => {
      try {
        const response = await getGeneric(`${apiConstants.GET_FRESHDESK_STATUS_LIST}`)
        const list = JSON.parse(response?.data?.responseObj)
        setStatusList(list?.choices)
      } catch (error) {
        enqueueSnackbar('Some error occurred in fetching status list!', { variant: 'error' })
        console.error(error)
      }
    }
    fetchStatusList()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const ndrCallcolumns = [
    {
      field: 'ndrresults',
      headerAlign: 'left',
      hideSortIcons: true,
      headerName: 'NDR Results',
      flex: 1,
      renderCell: (params) => {
        const { row } = params
        return (
          <Grid container rowSpacing={2}>
            <Grid item xs={12}>
              {row.ndr_result}
            </Grid>
          </Grid>
        )
      },
    },
    {
      field: 'ndr_outcome',
      headerAlign: 'left',
      hideSortIcons: true,
      headerName: 'Outcome',
      flex: 1,
      renderCell: (params) => {
        const { row } = params
        const outcome = row?.ndr_outcome === true ? 'TRUE' : 'FALSE'
        const color = row?.ndr_outcome === true ? 'success' : 'error'
        return (
          <Grid container rowSpacing={2}>
            <Grid item xs={12}>
              <Chip size='small' color={color} label={outcome} />
            </Grid>
          </Grid>
        )
      },
    },
    {
      field: 'startTime',
      headerAlign: 'left',
      hideSortIcons: true,
      headerName: 'Call time',
      flex: 1.1,
      renderCell: (params) => {
        const { row } = params
        return formatDate(row.call_start_time)
      },
    },
    {
      field: 'callDuration',
      headerAlign: 'left',
      hideSortIcons: true,
      headerName: 'Call Duration',
      flex: 1,
      renderCell: (params) => {
        const { row } = params
        const dur = Number(row?.call_duration) || 0
        return dur > 0 ? `${dur} min` : '-'
      },
    },
    {
      field: 'recordingURL',
      headerAlign: 'left',
      hideSortIcons: true,
      headerName: 'Recordings',
      flex: 1,
      renderCell: (params) => {
        const { row } = params
        return (
          <Link href={row.recording_url} target='_blank' rel='noopener noreferrer'>
            {row.recording_url ? 'Play' : '-'}
          </Link>
        )
      },
    },
    {
      field: 'failedOrders',
      align: 'center',
      headerAlign: 'center',
      hideSortIcons: true,
      headerName: 'Failed Orders',
      flex: 1,
      renderCell: (params) => {
        const { row } = params
        // console.log(row)
        if (row?.call_responses && row.call_responses.length > 0) {
          return (
            <Grid container rowSpacing={2}>
              <Grid item xs={12}>
                <Button
                  size='small'
                  variant='outlined'
                  sx={{ fontSize: 12, textTransform: 'none' }}
                  onClick={() => {
                    setNdrQ(row.call_responses)
                    setNdrQModal(true)
                  }}
                >
                  Questions asked to Customer
                </Button>
              </Grid>
            </Grid>
          )
        } else {
          return '-'
        }
      },
    },
  ]
  const nprCallcolumns = [
    {
      field: 'npr_result',
      headerAlign: 'left',
      hideSortIcons: true,
      headerName: 'NPR Results',
      flex: 1,
      renderCell: (params) => {
        const { row } = params
        return (
          <Grid container rowSpacing={2}>
            <Grid item xs={12}>
              {row.npr_result}
            </Grid>
          </Grid>
        )
      },
    },
    {
      field: 'npr_outcome',
      headerAlign: 'left',
      hideSortIcons: true,
      headerName: 'Outcome',
      flex: 1,
      renderCell: (params) => {
        const { row } = params
        const outcome = row?.npr_outcome === true ? 'TRUE' : 'FALSE'
        const color = row?.npr_outcome === true ? 'success' : 'error'
        return (
          <Grid container rowSpacing={2}>
            <Grid item xs={12}>
              <Chip size='small' color={color} label={outcome} />
            </Grid>
          </Grid>
        )
      },
    },
    {
      field: 'startTime',
      headerAlign: 'left',
      hideSortIcons: true,
      headerName: 'Call time',
      flex: 1.1,
      renderCell: (params) => {
        const { row } = params
        return formatDate(row.call_start_time)
      },
    },
    {
      field: 'callDuration',
      headerAlign: 'left',
      hideSortIcons: true,
      headerName: 'Call Duration',
      flex: 1,
      renderCell: (params) => {
        const { row } = params
        const dur = Number(row?.call_duration) || 0
        return dur > 0 ? `${dur} min` : '-'
      },
    },
    {
      field: 'recordingURL',
      headerAlign: 'left',
      hideSortIcons: true,
      headerName: 'Recordings',
      flex: 1,
      renderCell: (params) => {
        const { row } = params
        return (
          <Link href={row.recording_url} target='_blank' rel='noopener noreferrer'>
            {row.recording_url ? 'Play' : '-'}
          </Link>
        )
      },
    },
    {
      field: 'failedOrders',
      align: 'center',
      headerAlign: 'center',
      hideSortIcons: true,
      headerName: 'Failed Orders',
      flex: 1,
      renderCell: (params) => {
        const { row } = params
        // console.log(row)
        if (row?.call_responses && row.call_responses.length > 0) {
          return (
            <Grid container rowSpacing={2}>
              <Grid item xs={12}>
                <Button
                  size='small'
                  variant='outlined'
                  sx={{ fontSize: 12, textTransform: 'none' }}
                  onClick={() => {
                    setNdrQ(row.call_responses)
                    setNdrQModal(true)
                  }}
                >
                  Questions asked to Customer
                </Button>
              </Grid>
            </Grid>
          )
        } else {
          return '-'
        }
      },
    },
  ]
  const columnsNDRActionLog = [
    {
      field: 'ndrAction',
      hideSortIcons: true,
      headerName: 'Action Type',
      flex: 0.8,
    },
    {
      field: 'reattemptNumber',
      hideSortIcons: true,
      headerName: 'Reattempt Number',
      flex: 0.6,
    },
    {
      field: 'actionTakenBy',
      hideSortIcons: true,
      headerName: 'Action Taken By',
      flex: 1.2,
    },
    {
      field: 'reattemptRequestDate',
      headerAlign: 'center',
      hideSortIcons: true,
      headerName: 'Reattempt Request Date',
      flex: 0.8,
      renderCell: (params) => {
        const { row } = params
        return row.ndrCurrentAttemptDate ? parseDateAndTime(row?.ndrCurrentAttemptDate, true) : ''
      },
    },
    {
      field: 'actionDate',
      hideSortIcons: true,
      headerName: 'Action Date',
      flex: 0.7,
      renderCell: (params) => {
        const { row } = params
        return parseDateAndTime(row?.actionDate)
      },
    },
    {
      field: 'updatedAddress',
      hideSortIcons: true,
      headerName: 'Updated Address',
      flex: 1.5,
    },
    {
      field: 'landmark',
      hideSortIcons: true,
      headerName: 'Updated Landmark',
      flex: 1,
    },
    {
      field: 'updatedContactNumber',
      hideSortIcons: true,
      headerName: 'Update Contact',
      flex: 1,
    },
    {
      field: 'vocFile',
      hideSortIcons: true,
      headerName: 'BPR File',
      flex: 1.2,
      renderCell: (params) => {
        const { row } = params

        // Check if user has access and vocRemark exists
        if (row?.vocRemark && piiAccessAllow) {
          const latestUpdate = row?.vocRemark

          if (latestUpdate?.fileUrl) {
            // Get file extension for better display text
            const fileExtension = latestUpdate.fileUrl.split('.').pop()?.toLowerCase()

            // Determine display text based on file type
            let displayText = 'View File'
            let icon = '📄'

            if (['png', 'jpg', 'jpeg', 'webp', 'gif'].includes(fileExtension)) {
              displayText = 'View Image'
              icon = '🖼️'
            } else if (['mp3', 'wav', 'm4a', 'aac'].includes(fileExtension)) {
              displayText = 'Play Audio'
              icon = '🎵'
            } else if (['mp4', 'avi', 'mov', 'mkv'].includes(fileExtension)) {
              displayText = 'Play Video'
              icon = '🎬'
            } else if (fileExtension === 'pdf') {
              displayText = 'View PDF'
              icon = '📋'
            }

            return (
              <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                <span style={{ fontSize: '14px' }}>{icon}</span>
                <Link
                  href={latestUpdate.fileUrl}
                  target='_blank'
                  rel='noopener noreferrer'
                  style={{
                    color: '#1976d2',
                    textDecoration: 'underline',
                    cursor: 'pointer',
                    fontWeight: '500',
                    fontSize: '0.875rem',
                  }}
                >
                  {displayText}
                </Link>
              </div>
            )
          } else {
            return (
              <span
                style={{
                  color: '#666',
                  fontStyle: 'italic',
                  fontSize: '0.875rem',
                }}
              >
                No file attached
              </span>
            )
          }
        } else if (row?.vocRemark && !piiAccessAllow) {
          return (
            <span
              style={{
                color: '#d32f2f',
                fontWeight: '500',
                fontSize: '0.875rem',
                display: 'flex',
                alignItems: 'center',
                gap: '4px',
              }}
            >
              🔒 No Access
            </span>
          )
        } else {
          return (
            <span
              style={{
                color: '#999',
                fontSize: '0.875rem',
              }}
            >
              —
            </span>
          )
        }
      },
    },
  ]
  const columnsNPRActionLog = [
    {
      field: 'nprAction',
      hideSortIcons: true,
      headerName: 'Action Type',
      flex: 0.8,
    },
    {
      field: 'actionTakenBy',
      hideSortIcons: true,
      headerName: 'Action Taken By',
      flex: 1.2,
    },
    {
      field: 'nprCurrentAttemptDate',
      headerAlign: 'center',
      hideSortIcons: true,
      headerName: 'NPR Current Attempt Date',
      flex: 0.8,
      renderCell: (params) => {
        const { row } = params
        return row.nprCurrentAttemptDate ? parseDateAndTime(row?.nprCurrentAttemptDate, true) : ''
      },
    },
    {
      field: 'actionDate',
      hideSortIcons: true,
      headerName: 'Action Date',
      flex: 0.7,
      renderCell: (params) => {
        const { row } = params
        return parseDateAndTime(row?.actionDate)
      },
    },
    {
      field: 'landmark',
      hideSortIcons: true,
      headerName: 'Landmark',
      flex: 0.7,
    },
    {
      field: 'updatedAddress',
      hideSortIcons: true,
      headerName: 'Updated Address',
      flex: 0.7,
    },
    {
      field: 'updatedContactNumber',
      hideSortIcons: true,
      headerName: 'Updated Contact No.',
      flex: 0.7,
    },
  ]

  // EMS V2 tickets on this AWB (see fetchSupportTickets below).
  const emsV2SupportColumns = [
    {
      field: 'escalationNumber',
      headerAlign: 'left',
      headerName: 'Ticket ID',
      flex: 0.3,
      align: 'left',
    },
    {
      field: 'createdByName',
      headerAlign: 'left',
      flex: 0.4,
      headerName: 'Created By',
      align: 'left',
      renderCell: ({ row }) => row?.createdByName || '-',
    },
    {
      field: 'category',
      headerAlign: 'left',
      flex: 0.4,
      headerName: 'Category',
      align: 'left',
    },
    {
      field: 'subCategory',
      headerAlign: 'left',
      flex: 0.5,
      headerName: 'SubCategory',
      align: 'left',
    },
    {
      field: 'timeline',
      headerAlign: 'left',
      flex: 0.5,
      headerName: 'Timeline',
      align: 'left',
      renderCell: (params) => {
        const { row } = params
        return (
          <Box sx={{ fontSize: '0.75rem' }}>
            <Box sx={{ mb: 0.5 }}>
              <Typography variant='caption' sx={{ color: '#666', fontWeight: 'bold' }}>
                Created:
              </Typography>
              <Typography variant='caption' sx={{ ml: 1 }}>
                {parseDateAndTime(row?.createdAt)}
              </Typography>
            </Box>
            <Box>
              <Typography variant='caption' sx={{ color: '#666', fontWeight: 'bold' }}>
                Updated:
              </Typography>
              <Typography variant='caption' sx={{ ml: 1 }}>
                {parseDateAndTime(row?.updatedAt)}
              </Typography>
            </Box>
          </Box>
        )
      },
    },
    {
      field: 'status',
      headerAlign: 'left',
      flex: 0.5,
      headerName: 'Ticket Status',
      align: 'left',
      renderCell: ({ row }) => {
        const done = row?.statusCategory === 'RESOLVED' || row?.statusCategory === 'CLOSED'
        return row?.status ? <Chip color={done ? 'success' : 'warning'} size='small' label={row.status} /> : '-'
      },
    },
    {
      field: 'action',
      headerAlign: 'left',
      flex: 0.3,
      headerName: 'Action',
      align: 'left',
      renderCell: ({ row }) => <Button onClick={() => view(row?.id)}>View</Button>,
    },
  ]
  // Freshdesk tickets on this AWB, while EMS V2 is off (see fetchSupportTickets below).
  const freshdeskSupportColumns = [
    {
      field: 'id',
      headerAlign: 'left',
      headerName: 'TicketID',
      flex: 0.3,
      align: 'left',
      renderCell: (params) => {
        const { row } = params
        return row?.id
      },
    },
    {
      field: 'createdBy',
      headerAlign: 'left',
      flex: 0.4,
      headerName: 'Created By',
      align: 'left',
      renderCell: (params) => {
        const { row } = params
        return row.custom_fields?.cf_user_name ? row.custom_fields?.cf_user_name : '-'
      },
    },
    {
      field: 'category',
      headerAlign: 'left',
      flex: 0.4,
      headerName: 'Category',
      align: 'left',
      renderCell: (params) => {
        const { row } = params
        return row.custom_fields?.cf_category
      },
    },
    {
      field: 'subcategory',
      headerAlign: 'left',
      flex: 0.5,
      headerName: 'SubCategory',
      align: 'left',
      renderCell: (params) => {
        const { row } = params
        return row.custom_fields?.cf_sub_category
      },
    },
    {
      field: 'timeline',
      headerAlign: 'left',
      flex: 0.5,
      headerName: 'Timeline',
      align: 'left',
      renderCell: (params) => {
        const { row } = params
        return (
          <Box sx={{ fontSize: '0.75rem' }}>
            <Box sx={{ mb: 0.5 }}>
              <Typography variant='caption' sx={{ color: '#666', fontWeight: 'bold' }}>
                Created:
              </Typography>
              <Typography variant='caption' sx={{ ml: 1 }}>
                {parseDateAndTime(row?.created_at)}
              </Typography>
            </Box>
            <Box>
              <Typography variant='caption' sx={{ color: '#666', fontWeight: 'bold' }}>
                Updated:
              </Typography>
              <Typography variant='caption' sx={{ ml: 1 }}>
                {parseDateAndTime(row?.updated_at)}
              </Typography>
            </Box>
          </Box>
        )
      },
    },
    {
      field: 'status',
      headerAlign: 'left',
      flex: 0.5,
      headerName: 'Ticket Status',
      align: 'left',
      renderCell: (params) => {
        const { row } = params
        const status = statusList.find((elem) => elem.id === row?.status)
        if (status) {
          if (status?.id === 5) {
            return <Chip color='error' size='small' label={status.label_for_customers} />
          } else {
            return <Chip color='success' size='small' label={status.label_for_customers} />
          }
        }
        // return status?.label
      },
    },
    {
      field: 'action',
      headerAlign: 'left',
      flex: 0.3,
      headerName: 'Action',
      align: 'left',
      renderCell: (params) => {
        const { row } = params
        return (
          <>
            <Grid item container spacing={2}>
              {/* <Grid item xs={12} md={5}>
                                {row.status !== 5 ?
                                    <Button onClick={() => { toggleDelete(row?.id) }}>
                                        Close
                                    </Button> :
                                    <Button disabled>
                                        Close
                                    </Button>
                                }
                            </Grid> */}
              <Grid item xs={12} md={5}>
                <Button
                  onClick={() => {
                    view(row?.id, row.custom_fields?.cf_awb_number387695)
                  }}
                >
                  View
                </Button>
              </Grid>
            </Grid>
          </>
        )
      },
    },
  ]
  const supportColumns = EMS_V2_ENABLED ? emsV2SupportColumns : freshdeskSupportColumns
  const navigate = useNavigate()
  const view = (id, awb) => {
    navigate(EMS_V2_ENABLED ? `/support-v2/view?ticketId=${id}` : `/escalation_management/view?awb=${awb}&ticketId=${id}`)
  }


  const handleClose = () => {
    setViewQc(false)
  }

  // function getCourierLogo(courierId) {
  //     if (courierId) {
  //         let result = _.find(courierData, function (obj) {
  //             if (obj.id === courierId) {
  //                 return obj.logoUrl;
  //             }
  //         });
  //         return result?.logoUrl;
  //     }
  // }
  // const orderDetails = data?.data[0] || null;
  // const ndrActionLog = data?.data[0]?.ndrData?.actionUpdateLog || [];
  // const nprActionLog = data?.data[0]?.nprData?.actionUpdateLog || [];

  const orderDetails = data?.data[0] || null
  const ndrActionLog = data?.data[0]?.ndrData?.actionUpdateLog || []
  const nprActionLog = data?.data[0]?.nprData?.actionUpdateLog || []

  const isB2BOrder = orderDetails?.shipment_type === 'B2B' || orderDetails?.shipmentType === 'B2B'
  const orderRecordId = orderDetails?.id || orderDetails?._id
  const { data: odaData } = useGetB2BOdaCheckQuery(
    { orderId: orderRecordId },
    { skip: !isB2BOrder || !orderRecordId }
  )
  const odaHit = (odaData?.results || []).find((r) => r?.oda)
  const isDeliveryOda = !!odaHit

  // Delivery confirmation details from the courier (status code 8 = Delivered).
  const deliveredAdditional = orderDetails?.order_history?.find(
    (h) => h.orderStatusCode === 8
  )?.additional || null
  const odaTooltip = odaHit
    ? `Destination Pincode falls under ODA service area${odaHit.cp ? ` (${odaHit.cp}${odaHit.odaValue ? ` — ${odaHit.odaValue}` : ''})` : ''}.`
    : 'Destination Pincode falls under ODA service area.'

  const [otpCancellationDetails, setOtpCancellationDetails] = useState(null)
  const [otpCancellationModal, setOtpCancellationModal] = useState(false)
  const [loadingOtpDetails, setLoadingOtpDetails] = useState(false)
  const [isFetchingLabel, setIsFetchingLabel] = useState(false)

  const getOtpCancellationDetails = async () => {
    try {
      setLoadingOtpDetails(true)
      const payload = {
        merchantOid: orderDetails.merchantDetail?.key,
        awbNumbersList: [orderDetails.awb_number],
      }
      const res = await postGeneric(apiConstants.GET_OTP_CANCELLATION_DETAILS, payload)
      if (res?.status === 200) {
        setOtpCancellationDetails(res?.data)
      }
    } catch (error) {
      console.error('Failed to fetch OTP cancellation details:', error)
      enqueueSnackbar('Failed to fetch OTP cancellation details', { variant: 'error' })
    } finally {
      setLoadingOtpDetails(false)
    }
  }

  const handleOtpCancellationClick = async () => {
    setOtpCancellationModal(true)
    if (!otpCancellationDetails) {
      await getOtpCancellationDetails()
    }
  }

  const baseColumns = [
    {
      field: 'item_name',
      headerName: 'Name',
      flex: 1.2,
    },
    {
      field: 'item_description',
      headerName: 'Description',
      flex: 1.2,
    },
    {
      field: 'sku_id',
      headerName: 'SKU',
      flex: 1,
    },
    {
      field: 'units',
      headerName: 'Qty',
      flex: 0.5,
    },
    {
      field: 'tax',
      headerName: 'Tax',
      flex: 0.5,
      valueFormatter: (params) => {
        if (params.value == null) return ''
        return `${Number(params.value).toLocaleString()} %`
      },
    },
    {
      field: 'selling_price',
      headerName: 'Price',
      flex: 0.8,
      valueFormatter: (params) => {
        if (params.value == null) return ''
        return `₹ ${Number(params.value).toLocaleString()}`
      },
    },
    {
      field: 'item_url',
      headerName: 'Order Image',
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        const raw = params.row?.item_url
        const urls =
          raw && raw !== 'NA' && raw !== 'null'
            ? String(raw)
                .split(',')
                .map((u) => u.trim())
                .filter(Boolean)
            : []
        return <ProductImageThumbs images={urls} size={34} empty="No image" />
      },
    },
    {
      // Catalog images from Product Master for this SKU (fetched by merchantId +
      // skuCode). Thumbnails only — click opens the in-app carousel.
      field: 'productImages',
      headerName: 'Catalog Image',
      flex: 1,
      sortable: false,
      renderCell: (params) => (
        <ProductImageThumbs images={params.row?.productImages} size={34} empty="No image" />
      ),
    },
  ]

  if (orderDetails?.order_type === 'REVERSE SHIPMENT') {
    baseColumns.push({
      field: 'return_reason',
      headerName: 'Return Reason',
      flex: 1,
      renderCell: (params) => {
        return params.row?.return_reason ?? '-'
      },
    })
  }

  const columns = baseColumns

  const andfilter = [
    {
      field: 'awbNumber',
      operator: 'eq',
      value: waybill,
    },
  ]
  useEffect(() => {
    // Always exclude label_url and invoice_url by default - fetch them on demand when user clicks
    getShipmentDetail({
      excludes: exclude,
      andfilter: andfilter,
      offset: 0,
      limit: 1,
    }).then((res) => {
      let data = res.data
      const orderData = data?.data[0]
      let merchantOid = orderData?.merchantDetail?.key


      // Fetch support tickets after order details are loaded
      if (merchantOid) {
        const fetchSupportTickets = async () => {
          try {
            if (EMS_V2_ENABLED) {
              // EMS V2 scopes the search to the signed-in merchant; archived = closed tickets
              // imported from Freshdesk, which the merchant view only returns when asked for.
              const search = (extra) => postGeneric(apiConstants.ESCALATION_SEARCH_V2, { awbNumber: waybill, page: 0, size: 20, ...extra })
              const [current, archived] = await Promise.all([search({}), search({ archivedOnly: true })])
              setSupportTickets([...(current?.data?.results || []), ...(archived?.data?.results || [])])
            } else {
              const response = await post(
                `${apiConstants.BASE_LOCAL}${apiConstants.FILTER_FRESHDESK}`,
                {
                  awbnumber_list: [waybill],
                  page: page + 1,
                  merchantOid: merchantOid,
                }
              )
              const parsedRes = JSON.parse(response.data?.responseObj)
              setSupportTickets(parsedRes?.results)
            }
          } catch (error) {
            console.error('Error fetching support tickets:', error)
            enqueueSnackbar('Error fetching support tickets', { variant: 'error' })
          }
        }

        fetchSupportTickets()
      }
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [waybill, reload])

  // Fetch Product Master catalog images for this order's SKUs and map them by
  // sku_id so the "Product" column can show thumbnails. product_master.merchantId
  // holds the merchant OID (NOT the numeric merchantId) — which is exactly
  // orderDetails.merchantDetail.key — so we scope by that to avoid same-SKU
  // collisions across merchants.
  useEffect(() => {
    const items = orderDetails?.item_list || []
    const skus = [...new Set(items.map((it) => it?.sku_id).filter(Boolean))]
    if (!skus.length) {
      setSkuImageMap({})
      return
    }
    const merchantOid = orderDetails?.merchantDetail?.key
    const requestBody = {
      collection: 'product_master',
      offset: 0,
      limit: 200,
      skipCount: true,
      countOnly: false,
      andfilter: [
        ...(merchantOid ? [{ field: 'merchantId', operator: 'eq', value: merchantOid }] : []),
        { field: 'skuCode', operator: 'in', value: skus },
      ],
    }
    postGeneric(apiConstants.REPORT_GENERIC_SEARCH, requestBody)
      .then((res) => {
        const map = {}
        for (const p of res?.data?.data || []) {
          if (p?.skuCode) map[p.skuCode] = imagesOf(p)
        }
        setSkuImageMap(map)
      })
      .catch((err) => {
        console.log('product-master image fetch failed', err)
        setSkuImageMap({})
      })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderDetails?.id, orderDetails?.merchantDetail?.key])

  useEffect(() => {
    const payload = {
      // collection: 'futworks_ndr_recording',
      limit: 100,
      skipCount: true,
      countOnly: false,
      andfilter: [
        {
          field: 'awb_number',
          operator: 'eq',
          value: waybill,
        },
        // Scope call recordings to the shipment's own merchant. Recordings key on AWB only,
        // and couriers recycle AWB numbers across merchants — without this, another merchant's
        // NPR/NDR call logs (recorded customer calls) surface against a reused AWB. merchantOid
        // on the recording == orderDetails.merchantDetail.key (the merchant _id / OID).
        ...(orderDetails?.merchantDetail?.key
          ? [{ field: 'merchantOid', operator: 'eq', value: orderDetails.merchantDetail.key }]
          : []),
      ],
    }
    if(orderDetails?.order_type === 'REVERSE SHIPMENT' && orderDetails?.nprData) {
      postGeneric(apiConstants.NPR_RECORDING_SEARCH, payload)
      .then((res) => {
        // console.log(res?.data?.data)
        setNprCalls(res?.data?.data)
      })
      .catch((err) => {
        console.log(err)
      })
    }
    if(orderDetails?.order_type !== 'REVERSE SHIPMENT' && orderDetails?.ndrData) {
    postGeneric(apiConstants.NDR_RECORDING_SEARCH, payload)
      .then((res) => {
        // console.log(res?.data?.data)
        setNdrCalls(res?.data?.data)
      })
      .catch((err) => {
        console.log(err)
      })
    }
    fetchInsuranceDetails(waybill)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderDetails])

  // Remittance status/date live on the order itself already; only the UTR needs a lookup
  // of the settlement batch (report) the order was paid out under — reuses the existing
  // cod/filter/report endpoint by its `id` field, which already supports fetching one
  // report by _id (previously only ever called with merchant/month/year filters).
  const remittanceReportId = orderDetails?.merchantCODRemittanceRecord?.reportID
  useEffect(() => {
    if (!remittanceReportId) {
      setRemittanceReport(null)
      return
    }
    post(`${apiConstants.BASE_LOCAL}${apiConstants.COD_MERCHANT_REPORT}`, {
      id: remittanceReportId,
      limit: 1,
    })
      .then((res) => {
        const report = res?.data?.responseObj?.[0] || res?.data?.data?.[0] || null
        setRemittanceReport(report)
      })
      .catch((err) => {
        console.error('Error fetching remittance report:', err)
      })
  }, [remittanceReportId])

  if (isLoading || isFetching) {
    return <Loader />
  }
  const itemDetails = orderDetails ? orderDetails.item_list : []
  // const Length = ((orderDetails && orderDetails.shipment_detail[0].item_length) ? orderDetails.shipment_detail[0].item_length : "")
  // const Breadth = ((orderDetails && orderDetails.shipment_detail[0].item_breadth) ? orderDetails.shipment_detail[0].item_breadth : "")
  // const Height = ((orderDetails && orderDetails.shipment_detail[0].item_height) ? orderDetails.shipment_detail[0].item_height : "")
  // const item_detail = (orderDetails && orderDetails.order_history) ? (orderDetails.order_history) : [];
  const orderStatus = orderDetails && orderDetails.orderStatus ? orderDetails.orderStatus : ''
  // const printLable = () => {

  //     saveAs(
  //         orderDetails.label_url,
  //         `${orderDetails.awb_number}.pdf`
  //     );
  // };

  // zfunction getHeaderChip(){
  //     let headerChip={};
  //     if(['DELIVERED'].includes(currentStatus)){
  //         headerChip.key="Delivery Time"
  //         headerChip.color="#0abb87"
  //         headerChip.value= getTAT(orderDetails)
  //     }
  //     else{

  //     }
  //     return headerChip;

  // }
  const toggleCancel = () => {
    setCancelConfirm(true)
  }
  const cancelOrder = () => {
    // setLoading(true);
    get(`${apiConstants.BASE_LOCAL}${apiConstants.CANCEL_ORDER}?waybill=${query.get('waybill')}`)
      .then((response) => {
        // setLoading(false);
        let rs = response.data
        if (rs.meta && rs.meta.status && rs.meta.status === '200') {
          enqueueSnackbar('Cancelled successfully', { variant: 'success' })
          setReload(reload + 1)
        }
        if (rs.meta && rs.meta.status && rs.meta.status === '350') {
          enqueueSnackbar('Unable to cancel with courier partner at this point', {
            variant: 'warning',
          })
        } else if (rs.meta && rs.meta.status && rs.meta.status === '603') {
          enqueueSnackbar('Courier partner API cancellation not supported', { variant: 'error' })
        } else if (
          rs.meta &&
          rs.meta.status &&
          rs.meta.status !== '200' &&
          rs.meta.status !== '350' &&
          rs.meta.status !== '603'
        ) {
          enqueueSnackbar(rs.meta.message, { variant: 'error' })
        }
        // dispatch(getOrderLists({ "andfilter": andfilter, "offset": 0, "limit": 1 }));
      })
      .catch((err) => {
        console.error(err)
      })
  }

  const openDocument = async (url, type) => {
    // If URL is not available, fetch it first
    if (!url) {
      try {
        // Fetch order details with invoice URL included (remove from exclude)
        const excludeForInvoice = exclude
          .replace(/,label_url,invoice_url,b2bPackageLabelUrl/g, '')
          .replace(/label_url,invoice_url,b2bPackageLabelUrl,?/g, '')
        const response = await getShipmentDetail({
          excludes: excludeForInvoice,
          andfilter: andfilter,
          offset: 0,
          limit: 1,
        })

        const fetchedOrderData = response?.data?.data?.[0]
        const invoiceUrl = fetchedOrderData?.invoice_url

        if (invoiceUrl) {
          const newUrl = await getS3SignedUrl(
            invoiceUrl,
            {
              awbNumber: orderDetails?.awb_number,
              docType: type,
            },
            type
          )
          window.open(newUrl, true)
        } else {
          enqueueSnackbar('Invoice URL not available', { variant: 'warning' })
        }
      } catch (error) {
        enqueueSnackbar('Error fetching invoice URL', { variant: 'error' })
      }
    } else {
      const newUrl = await getS3SignedUrl(
        url,
        {
          awbNumber: orderDetails?.awb_number,
          docType: type,
        },
        type
      )
      window.open(newUrl, true)
    }
  }

  const handleFetchLabel = (reference) => {
    setIsFetchingLabel(true)
    if (reference) {
      get(
        `${apiConstants.BASE_LOCAL}${apiConstants.B2B_ORDER_FETCH_LABEL}?orderReference=${reference}`
      )
        .then((res) => {
          if (res.status === 200) {
            enqueueSnackbar('Label Fetched Successfully', { variant: 'success' })
            setReload(reload + 1)
          } else {
            enqueueSnackbar('Something went wrong', { variant: 'error' })
          }
        })
        .finally(() => setIsFetchingLabel(false))
    }
  }

  const handleViewLabel = async (url) => {
    // If URL is not available, fetch it first
    if (!url) {
      try {
        // Fetch order details with label URLs included (remove from exclude)
        const excludeForLabel = exclude
          .replace(/,label_url,invoice_url,b2bPackageLabelUrl/g, '')
          .replace(/label_url,invoice_url,b2bPackageLabelUrl,?/g, '')
        const response = await getShipmentDetail({
          excludes: excludeForLabel,
          andfilter: andfilter,
          offset: 0,
          limit: 1,
        })

        const fetchedOrderData = response?.data?.data?.[0]
        const labelUrl =
          orderDetails?.shipment_type === 'B2B'
            ? fetchedOrderData?.b2bPackageLabelUrl
            : fetchedOrderData?.label_url

        if (labelUrl) {
          const refreshedUrl = await refreshS3SignedUrl(labelUrl)
          window.open(refreshedUrl, '_blank')
        } else {
          enqueueSnackbar('Label URL not available', { variant: 'warning' })
        }
      } catch (error) {
        enqueueSnackbar('Error fetching label URL', { variant: 'error' })
      }
    } else {
      const refreshedUrl = await refreshS3SignedUrl(url)
      window.open(refreshedUrl, '_blank')
    }
  }

  const handleViewLRCopy = async (url) => {
    const refreshedUrl = await refreshS3SignedUrl(url)
    window.open(refreshedUrl, '_blank')
  }

  return (
    <div id='main-content' className='container-fluid'>
      <ConfirmDialog
        title=''
        open={cancelConfirm}
        setOpen={setCancelConfirm}
        onConfirm={() => cancelOrder()}
      >
        Are you sure you want to cancel this order ?
      </ConfirmDialog>
      <MUIModal
        open={viewQc}
        handleClose={handleClose}
        children={<QcDetails data={row} />}
        title={'Qc Link'}
        maxWidth='sm'
      />
      <PageTitle>Shipment Details / {orderDetails?.awb_number}</PageTitle>
      <StatusBanner
        orderDetails={orderDetails}
        onOtpCancellationClick={handleOtpCancellationClick}
        waVerified={waVerified}
      />
      <SummaryCards
        orderDetails={orderDetails}
        channelAccess={channelAccess}
        insuranceDetails={insuranceDetails}
      />
      <DocumentsBar
        orderDetails={orderDetails}
        onViewLabel={handleViewLabel}
        onViewInvoice={openDocument}
        onViewLRCopy={handleViewLRCopy}
        onFetchLabel={handleFetchLabel}
        isFetchingLabel={isFetchingLabel}
      />
      {orderDetails?.isWDSetteled === true && (
        <SectionCard title='Weight Discrepancy'>
          <InfoRow label='Status' value={orderDetails?.wdStatus || null} />
          <InfoRow
            label='Updated Merchant Price'
            value={orderDetails?.wdChargedPriceMerchant ? formatCurrency(orderDetails.wdChargedPriceMerchant) : null}
          />
          <InfoRow
            label='Updated Weight'
            value={orderDetails?.wdChargedWeight ? `${orderDetails.wdChargedWeight / 1000} kg` : null}
          />
        </SectionCard>
      )}
      {/* PTL documents, in the same place and order as the Admin Panel's Order Details */}
      <CurrentAppointmentCard order={orderDetails} />
      <AdditionalDocumentsCard order={orderDetails} />
      <PreviousAppointmentsCard order={orderDetails} />
      {orderDetails?.payment_mode === 'COD' && (
        <SectionCard title='COD Remittance'>
          <InfoRow
            label='Remittance Status'
            value={orderDetails?.merchantRemittanceStatus ? 'Remitted' : 'Pending'}
          />
          <InfoRow
            label='Remittance Date'
            value={orderDetails?.merchantCODRemittanceRecord?.reportRemitTime
              ? formatDate(orderDetails.merchantCODRemittanceRecord.reportRemitTime, 'dd MMM, yyyy')
              : null}
          />
          <InfoRow
            label='Remittance UTR'
            value={(remittanceReport?.merchantPaymentDetails || []).map((p) => p.utrNo).filter(Boolean).join(', ') || null}
          />
        </SectionCard>
      )}
      {orderDetails?.order_type === 'REVERSE SHIPMENT' ? (
        <Grid container spacing={2} sx={{ mb: 2 }}>
          <Grid item xs={12} md={6}>
            <Box sx={{ borderRadius: '14px', border: `1px solid ${BORDER}`, height: '100%', '& .MuiCardHeader-root': { bgcolor: '#F9FAFB', borderBottom: `1px solid ${BORDER}`, py: 1.25, px: 2.5 }, '& .MuiCardHeader-title': { fontFamily: FONT, fontSize: SIZE.xs, fontWeight: WEIGHT.bold, color: NAVY }, '& .MuiCardHeader-action': { mt: 0, mr: 0, alignSelf: 'center' }, '& .MuiCardContent-root': { px: 2.5, py: 1.5 } }}>
              <PIIDetails
                isReverseShipment={true}
                merchantOid={orderDetails?.merchantDetail?.key}
                reference={orderDetails?.reference}
                awbNumber={orderDetails?.awb_number}
                title='Customer Details'
                fallbackComponent={({ email, phone }) => (
                  <>
                    <InfoRow label='Pickup Name' value={orderDetails?.pickup_details?.from_name} />
                    <InfoRow label='Phone Number' value={phone} />
                    <InfoRow label='Email ID' value={email} />
                    <InfoRow
                      label='Address'
                      value={shouldMaskDataPD(report, orderDetails, piiAccessAllow)
                        ? maskAddress(addressStringWithPrefix('from', orderDetails?.pickup_details))
                        : addressStringWithPrefix('from', orderDetails?.pickup_details)}
                    />
                  </>
                )}
              />
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <SectionCard title='Warehouse Details' sx={{ mb: 0, height: '100%' }}>
              <InfoRow label='Customer Name' value={orderDetails?.delivery_details?.to_name} />
              <InfoRow
                label='Phone Number'
                value={shouldMaskData(report, orderDetails, piiAccessAllow)
                  ? maskPhoneNumber(orderDetails?.delivery_details?.to_phone_number)
                  : orderDetails?.delivery_details?.to_phone_number}
              />
              <InfoRow
                label='Email ID'
                value={shouldMaskData(report, orderDetails, piiAccessAllow)
                  ? maskEmail(orderDetails?.delivery_details?.to_email)
                  : orderDetails?.delivery_details?.to_email}
              />
              <InfoRow
                label='Shipping Address'
                value={shouldMaskData(report, orderDetails, piiAccessAllow)
                  ? maskAddress(addressStringWithPrefix('to', orderDetails?.delivery_details))
                  : addressStringWithPrefix('to', orderDetails?.delivery_details)}
                extra={isDeliveryOda && (
                  <Tooltip title={odaTooltip}>
                    <Chip label='ODA : true' color='warning' size='small' sx={{ ml: 1 }} />
                  </Tooltip>
                )}
              />
            </SectionCard>
          </Grid>
        </Grid>
      ) : (
        <Grid container spacing={2} sx={{ mb: 2 }}>
          <Grid item xs={12} md={4}>
            <SectionCard title='Pickup Details' sx={{ mb: 0, height: '100%' }}>
              <InfoRow label='Pickup Name' value={orderDetails?.pickup_details?.from_name} />
              <InfoRow
                label='Phone Number'
                value={shouldMaskDataPD(report, orderDetails, piiAccessAllow)
                  ? maskPhoneNumber(orderDetails?.pickup_details?.from_phone_number)
                  : orderDetails?.pickup_details?.from_phone_number}
              />
              <InfoRow
                label='Email ID'
                value={shouldMaskDataPD(report, orderDetails, piiAccessAllow)
                  ? maskEmail(orderDetails?.pickup_details?.from_email)
                  : orderDetails?.pickup_details?.from_email}
              />
              <InfoRow
                label='Address'
                value={shouldMaskDataPD(report, orderDetails, piiAccessAllow)
                  ? maskAddress(addressStringWithPrefix('from', orderDetails?.pickup_details))
                  : addressStringWithPrefix('from', orderDetails?.pickup_details)}
              />
            </SectionCard>
          </Grid>
          <Grid item xs={12} md={4}>
            <Box sx={{ borderRadius: '14px', border: `1px solid ${BORDER}`, height: '100%', '& .MuiCardHeader-root': { bgcolor: '#F9FAFB', borderBottom: `1px solid ${BORDER}`, py: 1.25, px: 2.5 }, '& .MuiCardHeader-title': { fontFamily: FONT, fontSize: SIZE.xs, fontWeight: WEIGHT.bold, color: NAVY }, '& .MuiCardHeader-action': { mt: 0, mr: 0, alignSelf: 'center' }, '& .MuiCardContent-root': { px: 2.5, py: 1.5 } }}>
              <PIIDetails
                isReverseShipment={false}
                merchantOid={orderDetails?.merchantDetail?.key}
                reference={orderDetails?.reference}
                awbNumber={orderDetails?.awb_number}
                title='Delivery Details'
                fallbackComponent={({ email, phone }) => (
                  <>
                    <InfoRow label='Customer Name' value={orderDetails?.delivery_details?.to_name} />
                    <InfoRow label='Phone Number' value={phone} />
                    <InfoRow label='Email ID' value={email} />
                    <InfoRow
                      label='Shipping Address'
                      value={shouldMaskData(report, orderDetails, piiAccessAllow)
                        ? maskAddress(addressStringWithPrefix('to', orderDetails?.delivery_details))
                        : addressStringWithPrefix('to', orderDetails?.delivery_details)}
                      extra={isDeliveryOda && (
                        <Tooltip title={odaTooltip}>
                          <Chip label='ODA : true' color='warning' size='small' sx={{ ml: 1 }} />
                        </Tooltip>
                      )}
                    />
                    {deliveredAdditional?.receiver_name && (
                      <InfoRow label='Receiver Name' value={deliveredAdditional.receiver_name} />
                    )}
                    {deliveredAdditional?.latitude && (
                      <InfoRow label='Latitude of Delivery' value={deliveredAdditional.latitude} />
                    )}
                    {deliveredAdditional?.longitude && (
                      <InfoRow label='Longitude of Delivery' value={deliveredAdditional.longitude} />
                    )}
                  </>
                )}
              />
              {orderDetails?.pods?.length > 0 && (
                <Box sx={{ px: 2.5, pb: 1.5 }}>
                  <InfoRow
                    label='POD'
                    value={
                      <Box sx={{ display: 'flex', gap: 1.5, flexWrap: 'wrap' }}>
                        {orderDetails.pods.map((pod, i) => (
                          <Link
                            key={i}
                            component='button'
                            onClick={async () => {
                              const url = await refreshS3SignedUrl(pod.preSignedUrl)
                              window.open(url, '_blank')
                            }}
                            sx={{ fontFamily: FONT, fontSize: SIZE['2xs'], fontWeight: WEIGHT.semibold }}
                          >
                            POD {i + 1}
                          </Link>
                        ))}
                      </Box>
                    }
                  />
                </Box>
              )}
            </Box>
          </Grid>
          <Grid item xs={12} md={4}>
            <SectionCard title='Return Details' sx={{ mb: 0, height: '100%' }}>
              <InfoRow label='Return Name' value={orderDetails?.return_details?.name} />
              <InfoRow
                label='Phone Number'
                value={shouldMaskDataPD(report, orderDetails, piiAccessAllow)
                  ? maskPhoneNumber(orderDetails?.return_details?.phone_number)
                  : orderDetails?.return_details?.phone_number}
              />
              <InfoRow
                label='Email ID'
                value={shouldMaskDataPD(report, orderDetails, piiAccessAllow)
                  ? maskEmail(orderDetails?.return_details?.email)
                  : orderDetails?.return_details?.email}
              />
              <InfoRow
                label='Return Address'
                value={shouldMaskDataPD(report, orderDetails, piiAccessAllow)
                  ? maskAddress(orderDetails?.return_details?.address)
                  : addressStringWithPrefixRAddr(orderDetails?.return_details)}
              />
            </SectionCard>
          </Grid>
        </Grid>
      )}
      {itemDetails && itemDetails.length > 0 && (
        <SectionCard title='Product Details'>
          <ProzoDataGrid
            columns={orderDetails?.shipment_type === 'B2B' ? columns2 : columns}
            rows={itemDetails.map((val, index) => ({
              ...val,
              id: index,
              productImages: skuImageMap[val?.sku_id] || [],
            }))}
            getRowId={(row) => row?.id}
            hideFooterPagination={true}
            autoHeight
            pagination={false}
          />
        </SectionCard>
      )}
      {orderDetails?.order_type === 'REVERSE SHIPMENT' && (
        <SectionCard title='QC Details at Pickup'>
          <InfoRow label='QC Verified Pickup' value={orderDetails?.qc_type ? 'Yes' : 'No'} />
          <InfoRow
            label='QC Remarks'
            value={(() => {
              if (!orderDetails?.order_history) return '-'
              const pickupFailed = orderDetails.order_history.find(
                (item) => item?.orderStatusEnum === 'PICKUP_FAILED'
              )
              return pickupFailed ? pickupFailed.remark || '-' : '-'
            })()}
          />
          {orderDetails?.qcDetails && (
            <Box sx={{ mt: 1 }}>
              <Typography sx={{ fontFamily: FONT, fontSize: SIZE['2xs'], color: SUBTLE, fontWeight: WEIGHT.medium, mb: 0.5 }}>
                QC Images
              </Typography>
              <Stack direction='row' spacing={1} flexWrap='wrap'>
                {orderDetails.qcDetails.images?.length > 0 ? (
                  orderDetails.qcDetails.images.map((imgObj, idx) => {
                    const imgUrl = typeof imgObj === 'string' ? imgObj : imgObj?.signedLink
                    return (
                      <Box key={idx} sx={{ mr: 1, mb: 1 }}>
                        <a href={imgUrl} target='_blank' rel='noopener noreferrer'>
                          <img
                            src={imgUrl}
                            alt={`QC Image ${idx + 1}`}
                            style={{
                              width: 60,
                              height: 60,
                              objectFit: 'cover',
                              borderRadius: 4,
                              border: `1px solid ${BORDER}`,
                            }}
                          />
                        </a>
                      </Box>
                    )
                  })
                ) : (
                  <Typography sx={{ fontFamily: FONT, fontSize: SIZE['2xs'], color: SUBTLE }}>
                    No Images
                  </Typography>
                )}
              </Stack>
            </Box>
          )}
        </SectionCard>
      )}
      <SectionCard title='All Shipment Scans'>
        <OrderTimeline
          orderDetailInfo={orderDetails ? orderDetails : []}
          cancelledBy={orderDetails?.cancelledBy}
        />
      </SectionCard>
      {orderDetails && orderDetails.ndrData && (
        <SectionCard title='NDR Details'>
          <InfoRow label='NDR Reported Date' value={orderDetails.ndrData?.ndrReportedDate ? formatDate(orderDetails.ndrData.ndrReportedDate) : null} />
          <InfoRow label='NDR Re-reported Date' value={orderDetails.ndrData?.ndrRereportedDate ? formatDate(orderDetails.ndrData.ndrRereportedDate) : null} />
          <InfoRow label='Current NDR Status' value={orderDetails.ndrData?.ndrStatus || null} />
          <InfoRow label='NDR Age' value={orderDetails.ndrData?.ndrAge ? `${orderDetails.ndrData.ndrAge} days` : null} />
          <InfoRow label='OFD Count' value={orderDetails.ndrData?.ofdCount} />
          <InfoRow label='Reattempt Count' value={orderDetails.ndrData?.reAttemptCount} />
          {ndrActionLog?.length > 0 && (
            <Box sx={{ mt: 2 }}>
              <Typography sx={{ fontFamily: FONT, fontSize: SIZE['2xs'], fontWeight: WEIGHT.bold, color: NAVY, mb: 1 }}>
                NDR Action Log
              </Typography>
              <ProzoDataGrid
                columns={columnsNDRActionLog}
                getRowId={(row) => Math.random()}
                rows={ndrActionLog}
                hideFooterPagination={true}
                sizePerPage={sizePerPage}
                setSizePerPage={setSizePerPage}
                setPage={setPage}
                page={page}
                pagination={true}
                rowCount={ndrActionLog?.length || 0}
                autoHeight
              />
            </Box>
          )}
        </SectionCard>
      )}

      {ndrCalls?.length > 0 && (
        <SectionCard title='NDR Call Logs'>
          <ProzoDataGrid
            columns={ndrCallcolumns}
            autoHeight={true}
            rows={ndrCalls || []}
            pagination={false}
            hideFooterPagination={true}
            rowHeight={120}
            getRowId={(row) => row?.awb_number + row?.created_at}
          />
        </SectionCard>
      )}

      {supportTickets && supportTickets.length > 0 && (
        <SectionCard title='Support Tickets'>
          <ProzoDataGrid
            rows={supportTickets}
            columns={supportColumns}
            hideFooterPagination={true}
            autoHeight
            rowHeight={100}
            pagination={false}
            getRowId={(row) => row?.id}
          />
        </SectionCard>
      )}
      {orderDetails && orderDetails.nprData && (
        <SectionCard title='NPR Details'>
          <InfoRow label='NPR Reported Date' value={orderDetails.nprData?.nprReportedDate ? formatDate(orderDetails.nprData.nprReportedDate) : null} />
          <InfoRow label='NPR Re-reported Date' value={orderDetails.nprData?.nprRereportedDate ? formatDate(orderDetails.nprData.nprRereportedDate) : null} />
          <InfoRow label='Current NPR Status' value={orderDetails.nprData?.nprStatus || null} />
          <InfoRow label='NPR Age' value={orderDetails.nprData?.nprAge ? `${orderDetails.nprData.nprAge} days` : null} />
          <InfoRow label='OFP Count' value={orderDetails.nprData?.ofPCount} />
          <InfoRow label='Reattempt Count' value={orderDetails.nprData?.reAttemptCount} />
          {nprActionLog?.length > 0 && (
            <Box sx={{ mt: 2 }}>
              <Typography sx={{ fontFamily: FONT, fontSize: SIZE['2xs'], fontWeight: WEIGHT.bold, color: NAVY, mb: 1 }}>
                NPR Action Log
              </Typography>
              <ProzoDataGrid
                columns={columnsNPRActionLog}
                getRowId={(row) => Math.random()}
                rows={nprActionLog}
                hideFooterPagination={true}
                sizePerPage={sizePerPage}
                setSizePerPage={setSizePerPage}
                setPage={setPage}
                page={page}
                pagination={true}
                rowCount={nprActionLog?.length || 0}
                autoHeight
              />
            </Box>
          )}
        </SectionCard>
      )}

      {nprCalls?.length > 0 && (
        <SectionCard title='NPR Call Logs'>
          <ProzoDataGrid
            columns={nprCallcolumns}
            autoHeight={true}
            rows={nprCalls || []}
            pagination={false}
            hideFooterPagination={true}
            rowHeight={120}
            getRowId={(row) => row?.awb_number + row?.created_at}
          />
        </SectionCard>
      )}

      {(orderDetails?.netra_address || orderDetails?.netra_rto) && (
        <Grid container spacing={2} sx={{ paddingTop: 2 }}>
          {orderDetails?.netra_address && (
            <Grid item xs={12} md={6}>
              <AddressQualityCard
                netra={orderDetails.netra_address}
                orderId={orderRecordId}
              />
            </Grid>
          )}
          {orderDetails?.netra_rto && (
            <Grid item xs={12} md={6}>
              <RtoRiskCard
                netra={orderDetails.netra_rto}
                orderId={orderRecordId}
              />
            </Grid>
          )}
        </Grid>
      )}
      {!orderDetails?.lifeCycleComplete && (
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', pt: 1, mb: 2 }}>
          <Button
            variant='outlined'
            color='error'
            size='small'
            startIcon={<CancelIcon />}
            onClick={toggleCancel}
            disabled={
              orderStatus === 'CANCELLED_ORDER' ||
              orderStatus === 'DELIVERED' ||
              orderStatus === 'FAILED_DELIVERY'
            }
            sx={{ fontFamily: FONT, fontSize: SIZE['2xs'], textTransform: 'none' }}
          >
            Cancel Order
          </Button>
        </Box>
      )}

      <MUIModal
        open={ndrQModal}
        title='Call Details'
        maxWidth={'lg'}
        handleClose={() => setNdrQModal(false)}
      >
        <ProzoDataGrid
          // autoHeight={false}
          columns={[
            {
              field: 'question',
              headerName: 'Question',
              flex: 3,
            },
            {
              field: 'answer',
              flex: 1,
              headerName: 'Answer',
            },
          ]}
          autoHeight={true}
          rows={ndrQ || []}
          pagination={false}
          hideFooterPagination={true}
          rowHeight={120}
          getRowId={(row) => Math.random()}
        />
      </MUIModal>

      <MUIModal
        open={otpCancellationModal}
        handleClose={() => setOtpCancellationModal(false)}
        maxWidth='md'
        title='OTP Cancellation Details'
        children={
          <Box sx={{ p: 2 }}>
            {loadingOtpDetails ? (
              <Loader />
            ) : otpCancellationDetails && otpCancellationDetails?.length > 0 ? (
              <Grid container spacing={2}>
                {otpCancellationDetails?.map((detail, index) => (
                  <Grid item xs={12} key={index}>
                    <Box sx={{ mb: 2, p: 2, borderRadius: '10px', border: `1px solid ${BORDER}` }}>
                      <Grid container spacing={2}>
                        <Grid item xs={6} md={4}>
                          <Typography sx={{ fontFamily: FONT, fontSize: SIZE['2xs'], color: SUBTLE, fontWeight: WEIGHT.medium }}>
                            AWB Number
                          </Typography>
                          <Typography sx={{ fontFamily: FONT, fontSize: SIZE['2xs'], color: NAVY }}>{detail.awbNumber || '-'}</Typography>
                        </Grid>
                        <Grid item xs={6} md={4}>
                          <Typography sx={{ fontFamily: FONT, fontSize: SIZE['2xs'], color: SUBTLE, fontWeight: WEIGHT.medium }}>
                            Timestamp
                          </Typography>
                          <Typography sx={{ fontFamily: FONT, fontSize: SIZE['2xs'], color: NAVY }}>
                            {detail.timestamp ? formatDate(detail.timestamp) : '-'}
                          </Typography>
                        </Grid>
                        <Grid item xs={6} md={4}>
                          <Typography sx={{ fontFamily: FONT, fontSize: SIZE['2xs'], color: SUBTLE, fontWeight: WEIGHT.medium }}>
                            Remark
                          </Typography>
                          <Typography sx={{ fontFamily: FONT, fontSize: SIZE['2xs'], color: NAVY }}>{detail.remark || '-'}</Typography>
                        </Grid>
                        <Grid item xs={6} md={4}>
                          <Typography sx={{ fontFamily: FONT, fontSize: SIZE['2xs'], color: SUBTLE, fontWeight: WEIGHT.medium }}>
                            Location
                          </Typography>
                          <Typography sx={{ fontFamily: FONT, fontSize: SIZE['2xs'], color: NAVY }}>{detail.location || '-'}</Typography>
                        </Grid>
                      </Grid>
                    </Box>
                  </Grid>
                ))}
              </Grid>
            ) : (
              <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
                <Typography>No cancellation details found.</Typography>
              </Box>
            )}
          </Box>
        }
      />
    </div>
  )
}

export default withLayout(OrderDetail)
